/**
 * Shared token accessor for data-source hooks.
 *
 * Reads getToken from AppContext (populated by ClerkSync in live mode).
 * In mockup mode, returns a no-op that resolves to null.
 * Safe to call in both mockup and live mode — no direct Clerk dependency.
 */
import { useAppContext } from '@/context/AppContext';

export function useToken() {
  const { getToken } = useAppContext();
  return getToken;
}
